import * as ambassadorWixEmailMarketingV1SenderDetails from './email-marketing-v1-sender-details-sender-details.http.js';
import * as ambassadorWixEmailMarketingV1SenderDetailsTypes from './email-marketing-v1-sender-details-sender-details.types.js';
import * as ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes from './email-marketing-v1-sender-details-sender-details.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSenderDetails(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.GetSenderDetailsRequest,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.GetSenderDetailsRequest,
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.GetSenderDetailsResponse,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.GetSenderDetailsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1SenderDetails.get(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/sender-details',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateSenderDetails(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.UpdateSenderDetailsRequest,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.UpdateSenderDetailsRequest,
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.UpdateSenderDetailsResponse,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.UpdateSenderDetailsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1SenderDetails.update(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/sender-details',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function verifyEmail(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.VerifySenderEmailRequest,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.VerifySenderEmailRequest,
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.VerifySenderEmailResponse,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.VerifySenderEmailResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1SenderDetails.verifyEmail(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/sender-details/verify-email',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function resolveActualFromAddress(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.ResolveActualFromAddressRequest,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.ResolveActualFromAddressRequest,
  ambassadorWixEmailMarketingV1SenderDetailsUniversalTypes.ResolveActualFromAddressResponse,
  ambassadorWixEmailMarketingV1SenderDetailsTypes.ResolveActualFromAddressResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1SenderDetails.resolveActualFromAddress(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/sender-details/actual-from-address',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SenderDetails as SenderDetailsOriginal,
  GetSenderDetailsRequest as GetSenderDetailsRequestOriginal,
  GetSenderDetailsResponse as GetSenderDetailsResponseOriginal,
  UpdateSenderDetailsRequest as UpdateSenderDetailsRequestOriginal,
  UpdateSenderDetailsResponse as UpdateSenderDetailsResponseOriginal,
  VerifySenderEmailRequest as VerifySenderEmailRequestOriginal,
  VerifySenderEmailResponse as VerifySenderEmailResponseOriginal,
  ResolveActualFromAddressRequest as ResolveActualFromAddressRequestOriginal,
  ResolveActualFromAddressResponse as ResolveActualFromAddressResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  VerifyEmailApplicationErrors as VerifyEmailApplicationErrorsOriginal,
} from './email-marketing-v1-sender-details-sender-details.types.js';
